<template>
	<el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" top="20px" width="1200px">
		<div slot="title"> <span style="font-size:18px">申请结算</span><span style="font-size:14px;color: #909399;margin-left: 10px;">只结算订单状态为订单完成一个月以前的订单</span> </div>
		<div class=" order">
			<div class="right-main">
				<!--      查询订单-->
				<el-form :inline="true" :model="formInline" class="demo-form-inline">
					<el-row>
						<!-- <el-col v-permission="'oms:admin:order:one'" :span="6">
							<el-form-item label="订单号:"><el-input v-model="formInline.orderNo" placeholder="请输入订单号"></el-input></el-form-item>
						</el-col> -->
						<el-col :span="6">
							<el-form-item label="平台名称:" v-if="storeListByCodeContent.length == 0">
								<el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
									<el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="平台名称:" v-if="storeListByCodeContent.length != 0">
								<el-select clearable v-model="platformName" :filter-method="filterByName" :disabled="true" filterable placeholder="请输入平台名称">
									<el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="平台号:">
								<el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" :disabled="storeListByCodeContent.length !== 0 ? true : false" filterable placeholder="请输入平台号">
									<el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="6">
							<el-form-item label="支付状态:">
								<el-select v-model="formInline.paymentStatus" disabled placeholder="请选择" clearable>
									<el-option label="" value="">全部</el-option>
									<el-option label="已支付" value="PAID"></el-option>
									<el-option label="未支付" value="UNPAID"></el-option>
									<el-option label="支付失败" value="FAILED"></el-option> // 注释
								</el-select>
							</el-form-item>
						</el-col> -->
						<!-- <el-col :span="6">
							<el-form-item label="支付方式:">
								<el-select v-model="formInline.paymentType" placeholder="请选择" clearable>
									<el-option label="" value="">全部</el-option>
									<el-option label="微信" value="WXPAY"></el-option>
									<el-option label="支付宝" value="ALIPAY"></el-option>
									<el-option label="余额" value="VPAY"></el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="6">
							<el-form-item label="结算状态:">
								<el-select v-model="formInline.paymentType" placeholder="请选择" clearable>
									<el-option label="" value="">全部</el-option>
									<el-option label="微信" value="WXPAY"></el-option>
									<el-option label="支付宝" value="ALIPAY"></el-option>
									<el-option label="余额" value="VPAY"></el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="6">
							<el-form-item label="订单状态:">
								<el-select v-model="formInline.orderStatus" placeholder="请选择" clearable>
									<el-option label="" value="">全部</el-option>
									<el-option v-for="(v, k) in $config.orderStatus" :key="k" :label="v" :value="k"></el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="6">
							<el-form-item label="业务:">
								<el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
									<el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
						<el-col :span="12">
							<el-form-item label="订单已完成日期:" class="el-date-width date">
								<el-date-picker clearable v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期"
									end-placeholder="请选择结束日期" :picker-options="pickerOptions" style="width: 300px;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6" class="fn-right form-btn">
							<el-button @click="apply()" round type="primary">结算</el-button>
							<el-button @click="search()" round>查询</el-button>
						</el-col>
					</el-row>
				</el-form>
				<div class="data-list">
					<el-table ref="table" :data="tableData" fit border :row-class-name="rowClassName" style="width: 100%" @selection-change="handleSelectionChange" row-key="orderId">
						<el-table-column type="selection" reserve-selection width="55"></el-table-column>
						<el-table-column label="订单号" fixed="left" min-width="210px">
							<template v-slot="scope">
								<span @click="$router.push({ path: '/orderdetail', query: { orderNo: scope.row.orderNo, way: 1 } })" class="color-blue"> {{ scope.row.orderNo }} </span>
							</template>
						</el-table-column>
						<el-table-column prop="storeCode" label="平台号" min-width="100px"></el-table-column>
						<!-- <el-table-column prop="phone" label="用户名" min-width="200px"></el-table-column> -->
						<el-table-column prop="storeName" label="平台名称" min-width="120px"></el-table-column>
						<el-table-column prop="salesman" label="业务" min-width="120px"></el-table-column>
						<el-table-column prop="priceTotal" label="会员总价" min-width="80px"></el-table-column>
						<el-table-column prop="cpriceTotal" label="零售总价" min-width="80px"></el-table-column>
						<el-table-column prop="priceReal" label="实付总价" min-width="80px"></el-table-column>
						<el-table-column label="结算金额" min-width="80px">
							<template slot-scope="scope"> {{ scope.row.settlementAmount === undefined ? 0 : scope.row.settlementAmount }} </template>
						</el-table-column>
						<el-table-column label="支付状态" min-width="80px">
							<template slot-scope="scope"> {{ scope.row.paymentStatus === 'UNPAID' ? '未支付' : '已支付' }} </template>
						</el-table-column>
						<el-table-column prop="paymentType" label="支付方式" min-width="80px">
							<template slot-scope="scope">
								<span>{{ $config.paymentType[scope.row.paymentType] }}</span>
							</template>
						</el-table-column>
						<el-table-column label="订单完成日期" min-width="180px" prop="dateCompleted"></el-table-column>
						<el-table-column prop="datePayment" label="支付日期" min-width="180px"></el-table-column>
						<el-table-column prop="orderStatus" label="订单状态">
							<template slot-scope="scope">
								<span>{{ $config.orderStatus[scope.row.orderStatus] }}</span>
							</template>
						</el-table-column>
						<el-table-column label="开票状态" min-width="100px">
							<template slot-scope="scope">
								<span :style="scope.row.invoice ? 'color:blue;cursor: pointer;' : ''" @click="invoicePage(scope.row)"> {{ scope.row.invoice ? '已开票' : '未开票' }} </span>
							</template>
						</el-table-column>
						<el-table-column label="结算状态" min-width="100px">
							<template slot-scope="scope">
								<span>{{ $config.settlementStatus[scope.row.settlementStatus] }}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="storeType" label="平台类型">
							<template slot-scope="scope">
								<span>
									{{ scope.row.storeType === 'WXBIZ' ? '微商' : scope.row.storeType === 'STUDIO' ? '影楼' : scope.row.storeType === 'FULFILLER' ? '后期' : '' }}
								</span>
							</template>
						</el-table-column>

						<el-table-column prop="dateSubmitted" label="创建日期" min-width="200px"></el-table-column> -->
						<!-- <el-table-column prop="priceReal" label="平台价格" min-width="200px"></el-table-column> -->
						<!-- <el-table-column label="结算状态"></el-table-column> -->
					</el-table>
					<!--    分页-->
					<v-pagination class="v-pagination" @changePage="changePage" :queryInfo="queryInfo"></v-pagination>
				</div>
			</div>
			<order-dialog ref="orderDialogRef"></order-dialog>
		</div>
	</el-dialog>
</template>
<script>
import BigNumber from 'bignumber.js'
import VPagination from '@/components/Pagination/index.vue'
import OrderDialog from '@/components/Dialog/OrderDialog/OrderStatusDialog/index.vue'
import { order, settlementListOrder, settlementApply, orderPaymentTypeStatistic, orderLogList, orderExport } from '@/api/oms'
import { storeTypeGetStoreTypeList, storeQueryListByCode, getSalesmanByFullName, storeQueryListByName, getAllUsersByUserName } from '@/api/crm'
export default {
	name: 'order',
	components: {
		VPagination,
		OrderDialog
	},
	watch: {
		value2: {
			handler (val, oldVal) {
				console.log(val)
				if (val.length > 0) {
					this.formInline.dateStart = val[0] + ' 00:00:00'
					this.formInline.dateEnd = val[1] + ' 23:59:59'
				} else {
					this.formInline.dateStart = ''
					this.formInline.dateEnd = ''
				}
			},
			deep: true,
			immediate: true
		},
		storeListByCodeContent: {
			// 监控该变量，重新赋值并刷新图表
			handler (newVal, oldVal) {
				console.log(newVal, oldVal)
				console.log(this.storeListByCode)
				this.storeListByCodeContent = newVal
				if (this.storeListByCodeContent.length !== 0) {
					this.storeListByCodeContent.forEach((el, idx) => {
						console.log(el)
						this.formInline.storeId = el.code
						this.storeId = el.id
						this.platformName = el.name
					})
					this.storeListByCode = this.storeListByCodeContent
				}
				// this.formInline.storeId = newVal;
			},
			deep: true // 必须设置
		}
	},
	props: {
		storeListByCodeContent: {
			type: Array,
			default () {
				return []
			}
		}
	},
	data () {
		return {
			storeId: 0,
			platformName: '',
			selecedOrderList: [],
			dialogVisible: false,
			userList: [],
			salemanList: [],
			storeListByCode: [],
			queryInfo: {
				total: 0,
				pageNum: 1, // 当前显示第几页
				pageSize: 10 // 每一页显示条数
			},
			formInline: {
				channel: 'B2C',
				orderNo: '', // 订单号
				userName: '', // 用户名
				storeId: null,
				storeCode: '',
				storeName: '',
				agentName: '',
				orderType: null, // 订单类型
				paymentStatus: 'PAID', // 支付状态
				paymentType: null, // 支付方式
				orderStatus: 'SHIPPED', // 订单状态
				dateStart: null,
				dateEnd: null,
				salesmanId: null
			},
			tableData: [],
			basicsInfo: {
				storeId: '',
				storeCode: '',
				storeName: '',
				fullName: '',
				storeTypeList: []
			},
			value2: [
				// this.$moment()
				// 	.subtract(1, 'months')
				// 	.format('YYYY-MM-DD'),
				// this.$moment().format('YYYY-MM-DD')
				// this.$moment()
				// 	.subtract(2, 'months')
				// 	.format('YYYY-MM-DD'),
				// this.$moment()
				// 	.subtract(1, 'months')
				// 	.format('YYYY-MM-DD')
			],
			pickerOptions: {
				disabledDate (time) {
					// return time.getTime() > Date.now() - 8.64e6;
					var threeDate = new Date()
					threeDate.setMonth(threeDate.getMonth() - 1)
					return time.getTime() > threeDate - 8.64e6
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick (picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 37)
							end.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick (picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 60)
							end.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近三个月',
						onClick (picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 120)
							end.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit('pick', [start, end])
						}
					}
				]
			}
		}
	},
	mounted () {
		console.log('storeListByCodeContent: ', this.storeListByCodeContent)
	},
	methods: {
		show () {
			this.dialogVisible = true
			this.value2 = []
			this.formInline.dateStart = null
			this.formInline.dateEnd = null
			this.onSubmit()
			this.$refs.table.clearSelection()
		},
		handleSelectionChange (val) {
			console.log('val', val)
			this.selecedOrderList = val
		},
		apply () {
			console.log('this.handleSelectionChange: ', this.selecedOrderList)
			if (this.selecedOrderList.length === 0) {
				this.$notify({
					title: '失败',
					message: '请选择订单',
					type: 'error'
				})
				return
			}
			// 结算金额
			let amount = 0
			// 订单id
			let orders = []
			this.selecedOrderList.forEach((el, idx) => {
				console.log(el)
				let num = amount + Number(el.settlementAmount)
				console.log()
				if (num.toString().indexOf('.') !== -1) {
					let aa = num.toString().split('.')
					let len = aa[1].toString().split('.').length
					if (el.settlementAmount) len > 2 ? amount = Math.floor(Number(num) * 100) / 100 : amount = Number(num)
				} else {
					amount = new BigNumber(Number(num))
				}
				// amount = amount + el.settlementAmount
				orders.push(el.orderId)
			})
			console.log('amount', amount)
			let contentHtml =
				'<p><strong>结算后的订单不可申请退款、售后，结算金额将自动存到您的余额，是否结算？</strong></p><p>平台号：' +
				this.formInline.storeId +
				'</p><p>结算订单数：' +
				this.selecedOrderList.length +
				'</p><p>结算金额：' +
				amount +
				'</p>'
			let params = {
				orderIds: orders,
				storeId: this.storeId
			}
			this.$alert(contentHtml, '确定提示', {
				dangerouslyUseHTMLString: true
				// this.$confirm(content, '操作提示', {
				//   confirmButtonText: '确定'
			}).then(() => {
				settlementApply({ data: params }).then(res => {
					console.log(res)
					if (res.data.success) {
						this.$refs.table.clearSelection()
						this.onSubmit()
						this.$notify({
							title: '成功',
							message: '申请成功',
							type: 'success'
						})
					}
				})
			})
		},
		search () {
			this.queryInfo.pageNum = 1
			this.$refs.table.clearSelection()
			this.onSubmit()
		},
		async onSubmit () {
			const end = new Date()
			const start = new Date()
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 60)
			end.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
			let dataContent = Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))
			let params = {
				channel: dataContent.channel,
				completedDateEnd: dataContent.dateEnd ? dataContent.dateEnd : this.$moment(end).format('YYYY-MM-DD HH:mm:ss'),
				completedDateStart: dataContent.dateStart ? dataContent.dateStart : '1900-08-12 16:15:33',
				storeId: this.storeId,
				paymentStatus: 'PAID', // 支付状态
				orderStatus: 'COMPLETED', // 订单状态
				settlementStatus: 'UNSETTLED'// 结算状态 UNSETTLED CANCELLED
			}
			await order({
				page: this.queryInfo.pageNum - 1,
				size: this.queryInfo.pageSize,
				vo: params
			}).then(res => {
				this.queryInfo.total = res.data.data.total
				this.tableData = res.data.data.content
			})
			// let dataContent = Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]));
			// let params = {
			// 	dateEnd: dataContent.dateEnd,
			// 	dateStart: dataContent.dateStart,
			// 	storeId: this.storeId
			// };
			// settlementListOrder({ data: params }).then(res => {
			// 	// this.queryInfo.total = res.data.data.total;
			// 	this.tableData = res.data.data;
			// });
		},
		rowClassName ({ row, rowIndex }) {
			row.index = rowIndex
		},
		getOrderStatus (orderId) {
			this.$refs.orderDialogRef.show(orderId)
		},
		exportExcel () {
			let param = JSON.parse(JSON.stringify(this.formInline))
			if (!param.dateStart) {
				param.dateStart =
					this.$moment()
						.subtract(1, 'months')
						.format('YYYY-MM-DD') + ' 00:00:00'
				param.dateEnd = this.$moment().format('YYYY-MM-DD') + ' 00:00:00'
			}
			Object.keys(param).forEach(key => (param[key] === '' || param[key] === null) && delete param[key])
			orderExport(param).then(res => {
				let blob = res.data
				const fileReader = new FileReader()
				fileReader.readAsDataURL(blob)
				fileReader.onload = event => {
					let a = document.createElement('a')
					let _fileName = '订单表' + this.value2[0] + '-' + this.value2[1] + '.xls'
					a.download = _fileName
					a.href = event.target.result
					document.body.appendChild(a)
					a.click()
					document.body.removeChild(a)
				}
			})
		},
		handleSelect (item) {
			this.formInline.storeId = item.id
			this.basicsInfo.storeName = item.companyName
		},
		selectUserList (val) {
			if (val.trim()) {
				getAllUsersByUserName(val).then(res => {
					if (res.data.success) {
						this.userList = res.data.data
					}
				})
			}
		},
		selectSalemanList (val) {
			if (val.trim()) {
				getSalesmanByFullName(val).then(res => {
					if (res.data.success) {
						this.salemanList = res.data.data
					}
				})
			}
		},
		filterMethod (val) {
			if (val.trim()) {
				storeQueryListByCode(val).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		filterByName (val) {
			if (val.trim()) {
				storeQueryListByName(val).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		// querySearchAsync(queryString, cb) {
		//   storeQueryListByCode(queryString).then(res => {
		//     res.data.data.forEach(item => {
		//       item.value = item.code
		//     });
		//     cb(res.data.data)
		//   })
		// },
		SelectStoreName (item) {
			this.formInline.storeId = item.id
			this.basicsInfo.storeCode = item.code
		},
		queryStoreNameAsync (queryString, cb) {
			storeQueryListByName(queryString).then(res => {
				res.data.data.forEach(item => {
					item.value = item.code
				})
				cb(res.data.data)
			})
		},
		selectFullName (item) {
			this.formInline.salesmanId = item.id
		},
		queryFullNameAsync (queryString, cb) {
			// 改成业务的模糊查询
			getSalesmanByFullName(queryString).then(res => {
				res.data.data.forEach(item => {
					item.value = item.fullName
				})
				cb(res.data.data)
			})
		},
		changePage (val) {
			this.queryInfo = val
			this.onSubmit()
		}
	}
}
</script>
<style scoped lang="less">
@deep: ~'>>>';

/deep/ .date .el-form-item__label {
	width: 117px;
}
</style>
